import { render, staticRenderFns } from "./ChangeCardLogo.vue?vue&type=template&id=bd0d97d0"
import script from "./ChangeCardLogo.vue?vue&type=script&lang=js"
export * from "./ChangeCardLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports